import React, { useState } from "react";
import useDocumentList from "../../hooks/useDocumentList";
import InvoiceDataGrid from "./InvoiceDataGrid";
import InvoiceActivityLogs from "./InvoiceActivityLogs";
import DocumentHeader from "./DocumentHeader";
import canUserSeeThis from "../common/CheckCanUserSeeThis";
import { exportInvoiceToExcel } from "./exportInvoiceToExcel";

const DoList = () => {
  const [p1Value, setP1Value] = useState("ALL");
  const [modalType, setModalType] = useState(null);

  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    exportDocumentList,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList,
  } = useDocumentList({
    docType: "DORD",
    docLabel: "Delivery Order",
    p1Value,
    p2Value: "-",
    docNoField: "DO NO",
    editRoute: "/delivery_order",
    screenCode: "DOCOUNT",
    initialSearchType: "-",
  });

  const handleExport = () => {
    exportDocumentList();
  };

  const handleExportItems = async () => {
    const doNo = selectedRowData?.["DO NO"];
    if (!doNo) {
      alert("Please select a delivery order first");
      return;
    }
    try {
      const url = `${config.BASE_URL}/api/DocumentEditDetails/${config.COMPANY_CODE}/DORD/${doNo}/${config.DEPARTMENT_NO}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch item data");
      const itemData = await response.json();
      if (itemData && itemData.length > 0) {
        exportInvoiceToExcel(itemData, config.COMPANY_NAME, "DORD");
      } else {
        alert("No item data available for this delivery order");
      }
    } catch (err) {
      console.error("Error exporting items:", err);
      alert("Failed to export items. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <DocumentHeader
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        BASE_URL={config.BASE_URL}
        COMPANY_CODE={config.COMPANY_CODE}
        DEPARTMENT={config.DEPARTMENT_NO}
        title={"Document List"}
        searchTerm={searchTerm}
        searchType={searchType}
        setSearchTerm={setSearchTerm}
        setSearchType={setSearchType}
        filteredDocs={documentData}
        showType={p1Value}
        setShowType={setP1Value}
        total={totalCount}
        onExport={handleExport}
        onExportItems={handleExportItems}
        // onPrint={handlePrint}
        documentType={"DELIVERY_ORDER"}
        config={config}
        selectedRowData={selectedRowData}
        doctype="DO NO"
        showFilter={true}
      />
      <div className="max-w-full mx-auto py-2 space-y-4">
        <div className="grid grid-cols-12 gap-4">
          {showSidebar && (
            <InvoiceActivityLogs
              invoiceId={selectedRowData["DO NO"]}
              COMPANY_CODE={config.COMPANY_CODE}
              BASE_URL={config.BASE_URL}
              modificationType={"DOTIMELINE"}
              printType={"DOPRINTTIMELINE"}
              DEPARTMENT={config.DEPARTMENT_NO}
            />
          )}
          <div
            className={`col-span-12 ${showSidebar ? "lg:col-span-9" : "lg:col-span-12"
              } transition-all duration-300`}
          >
            <InvoiceDataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              onView={handleView}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentStart={currentStart}
              currentEnd={currentEnd}
              totalCount={totalCount}
              showSidebar={showSidebar}
              docLabel={"DO"}
              enableF5Action={
                config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN"
                  ? true
                  : canUserSeeThis("XS")
              }
              config={config}
              refreshDocumentList={refreshDocumentList}
              f5Mode={"DOSETTLEMENT"}
              modalType="close"
              setModalType={setModalType}
              showEdit={config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN" ||
                canUserSeeThis("-*AI")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoList;
